import { Box, Button, Divider, Drawer, FormControl, FormControlLabel, Grid, IconButton, MenuItem, OutlinedInput, Radio, RadioGroup, useMediaQuery } from "@mui/material";
import { Icon } from "components/Icons";
import React, { useEffect, useState } from "react";
import ContactForm from "./ContactForm";
import { get, getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";
import { useOpenHouseDrawer } from "./useOpenHouseDrawer";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { GETLEADTOKEN, POST_TESTLEAD } from "api/api";
import { CustomInput, CustomLabel, CustomSelect, PlaceHolderInputField  } from "./styled-components";
import { useFetch } from "hooks/fetch/useFetch";
import axios from "axios";
import { motion } from "framer-motion";
import SuccessMessage from "./SuccessMessage";
import { useOpenHouseData } from "components/OpenHouseBanner/OpenHouseBanner.Data";
import { PhoneNumberDropdown } from "components/AdvanceDropdown/PhoneNumberDropdown/Dropdown";
import { ReactSelect } from "components/AdvanceDropdown/NormalDropdown/Dropdown";
import { CheckBox } from "components/FormComponent/CheckBox";
import { PoweredBy } from "components/PoweredBy/PoweredBy";
import { useLocation } from "react-router-dom";
import { SearchDropdown } from "components/AdvanceDropdown/SeachDropdown/Dropdown";
import { CustomPlaceHolderInputField } from "components/FormComponent/TextField";
import { CustomButton } from "components/Unit/NewReservationButton";
import { enqueueSnackbar } from "notistack";
import EusButton from "components/Button/EusButton";
import { SelectDate } from "components/FormComponent/SelectDate";
import { useBreak } from "hooks/useBreak";
import { EventCalendar } from "components/Calendar/EventCalendar";
import dayjs from "dayjs";
import { Month } from "components/OpenHouseBanner/OpenHouseBanner.utilities";
import moment from "moment";
import { EmailField, TextField } from "components/MainFooter/FormField";

const OpenHouseDrawer = () => {
  const isFullEidoSite = ['frontpage', 'unitpage', 'propertypage']
  const [selectedEvent, setSelectedEvent] = useState(dayjs(new Date()))
  const [sEveData, setSEveData]           = useState([])

  const { ready, STime, ETime, MM, MMM,Date: fromDate, Ftitle, Time, Description, Address } = useOpenHouseData();

  const openhouses          = get(_project, 'openhouses')
  const [eDates, setEdates] = useState([])

  const sm                        = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const here                      = useLocation().pathname;
  const atUnit                    = here.includes("unit");
  const atFrontpage               = here.includes("frontpage");
  const atPropertyPage            = here.includes("propertypage");
  const isTab                     = useBreak('md_dn')
  const [submitted, setSubmitted] = useState(false);
  
  const [checked, setChecked]           = useState(false);
  const [checked2, setChecked2]           = useState(false);
  const [personName, setPersonName]     = useState([]);
  const [nationName, setNationName]     = useState([]);
  const [describeName, setDescribeName] = useState([]);
  const grid                            = false
  const { isOpen, toggle, unit }        = useOpenHouseDrawer();
  const isMobile                        = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { i18n: { language } }          = useTranslation();

  const { pin, pid } = useGet(active_project)
  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []
  const contactData  = getFocus(_project, 'ContactProperties')?.[pin]?.[pid] ?? []
  const testLeadData = useFetch({ url: GETLEADTOKEN('cf3f4a6f48810ec0c61fbb4e39beac4f') });

  const unitNo      = unit?.getValue("Projeknr") ? `${buttonsLabel?.find(btn => btn?.UILabelProperty === 'Bolignr')?.Label} ${unit.getValue("Projeknr")},` : "";
  const unitId      = unit?.getId();
  const sys_uid     = unit?.getValue('SVGID');
  const unitAddress = unit?.getAddress() ?? "";

 

  const { register, handleSubmit, setValue, getValues, watch, reset, control, formState: { errors, isValid }, } = useForm({ mode: "onChange",     defaultValues: {
    dateOfBirth: "",
    birth_date : "",
    birth_month: "",
    birth_year : "",
  }});
  const homeUrl  = 'https://estatetool.dk/';
  const unitUrl  = unit?.getUrl(`${homeUrl}/${language}`) ?? "";
  const onSubmit = (data) => {
    handleFormSubmit(data);
  };

  const handleFormSubmit = async (data) => {

  const utms = {
    utm_source  : "google",
    utm_medium  : "cpc",
    utm_campaign: "spring_sale",
    utm_content : "ad_variation_1"
  }

  let utmParam = {};
  for (let [key, value] of new URLSearchParams(location.search).entries()) {
    if(key === "utm_source" || key === "utm_medium" || key === "utm_campaign" || key === "utm_content") {
      utmParam[key] = value;
    }
  }

  const leadCountry_code = data?.country_id?.country_id
  const eventDateCMPId   = openhouses?.filter((op) => op.FromDate === selectedEvent?.format('YYYY-MM-DD'))
    const source = window.location.href;
    const media = isFullEidoSite.some((fe) => here.includes(fe));
    const isFES = media ? "Ei.DO website" : "Ei.DO boligvælger";


  const payload = new URLSearchParams({
   
    token        : testLeadData?.D?.token,
    hash         : testLeadData?.D?.hash,
    CAMPAIGN     : eventDateCMPId[0]?.CampaignID,
    // SYS_UID      : sys_uid,
    Fornavne     : data.firstname,
    Efternavn    : data.lastname,
    Email_privat : data.email,
    country_code : leadCountry_code,
    Telefon_mobil: data.phone,
    dob          : data.dateOfBirth,
    media: isFES,
    source,
    ANSWER_JSON: [],
    // postnummer   : data.postnummer,
    // Comments     : data.kommentar?.length ? data.kommentar: "",
    ...utmParam
  });

  // console.log(Object.fromEntries(payload), data)
    // enqueueSnackbar(variant ? language === "da" ? "Emailen er blevet sendt" : "The email has been sent" : language === "da" ? 'Fejl ved indsendelse af formular' : 'Error submitting form', { variant: variant ? 'success' : 'error' });


      axios.post(`${testLeadData?.D?.system_domain}/${POST_TESTLEAD}`, payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((data) => {
        setSubmitted(Object.keys(data || {}).length ? true : false);
        testLeadData.mutate()
        setPersonName([]);
        setNationName([]);
        setDescribeName([])
        reset();
        setChecked(false);
      })
        // .catch((err) => {
        //   enqueueSnackbar(language === "da" ? 'Noget gik galt. Prøv igen' : 'Something went wrong. Try again', { variant: 'error' });
        // });
  };

  useEffect(()=> {
    testLeadData.mutate()
  }, [language])

  useEffect(()=> {
    setSubmitted(false)
    setPersonName([]);
    setNationName([]);
    setDescribeName([])
    reset();
    setChecked(false);
    testLeadData.mutate()
  }, [isOpen])

  useEffect(()=> {
    let eventDateData = openhouses?.filter((op) => op.FromDate === selectedEvent?.format('YYYY-MM-DD'))
   
    if(eventDateData.length) {
      const fromTime = moment(eventDateData[0].FromTime, "HH:mm");
      const toTime   = moment(eventDateData[0].ToTime, "HH:mm");
      
      const diffMinutes = toTime.diff(fromTime, "minutes");
      const hours       = Math.floor(diffMinutes / 60);
      const minutes     = diffMinutes % 60;
      
        // Danish translation for hours and minutes
      let result  = hours > 0 ? `(${hours} time${hours > 1 ? "r" : ""}` : "";
          result += minutes > 0 ? `${hours > 0 ? " og " : "("}${minutes} minut${minutes > 1 ? "ter" : ""})` : (hours > 0 ? ")" : "");
      
      eventDateData[0].timeGap = result
      setSEveData(eventDateData)
    }

  }, [selectedEvent, openhouses])

  const handleNumberInput = (event) => {
    return (event.key.charCodeAt() >= 48 && event.key.charCodeAt() <= 57) || event.key === 'Backspace' ? event.key : event.preventDefault();
  };

  const handleCheckbox = (event) => {
    setChecked(event.target.checked);
  };

  const handleCheckbox2 = (event) => {
    setChecked2(event.target.checked);
  };

  useEffect(()=> {
    const PID = unit?.data?.ProjectID || pid
    const ftr = openhouses.filter((oh)=> oh.ProjectID == PID)
 
    setEdates(ftr)
  }, [unit?.data?.UnitID, isOpen])

  return (
    <Drawer
      hideBackdrop = {true}
      anchor       = {isMobile ? "bottom" : "right"}
      open         = {isOpen}
      onClose      = {() => toggle()}
      PaperProps   = {{ sx: { scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" }, color: f_clr.primaryText, backgroundColor: f_clr.primaryColor, height: { xs: `calc(100% - 162px - ${atUnit || atFrontpage || atPropertyPage ? isTab ? "-120px" : "-107px" : isTab ? "-115px" : "1px"})` }, top: `${isMobile ? "56px" : isTab ? '56px' : "70px"}`, justifyContent: "space-between", boxShadow: 'unset', paddingBottom: { xs:"16px", lg: 0 } } }}
      sx           = {{ "&.MuiDrawer-root": { width: 450, top: "70px", right: 0, left: 'unset', bottom: 'unset' } }}
    >
      <IconButton
          onClick = {toggle}
          sx      = {{
            position: "absolute",
            right   : 16,
            top     : 16,
            zIndex  : 10
          }}
        >
          <span className = "icon-hover-effect" >
          <Icon 
            icon = "close"
            sx   = {{
              fontSize: 18,
            }}
          />
          </span>
        </IconButton>
      <>
      {submitted ? (
        <motion.div
          initial    = {{ opacity: 0, scale: 0.5 }}
          animate    = {{ opacity: 1, scale: 1 }}
          transition = {{ duration: 0.5 }}
          style      = {{ height: "100%", display: "flex", alignItems: "center" }}
        >
             <SuccessMessage label = {false} msg = { language === 'da' ? `<div style={{ fontFamily: "Cerebri sans" }}><p>Tak for din tilmelding til åbent hus.<br/>  Vi glæder os til at se dig d. 
              ${dayjs(selectedEvent)?.format('D')} ${Month(selectedEvent, language)}.</p></div>` : `<div style={{ fontFamily: "Cerebri sans !important" }}><p>Thank you for registering for the open house.<br/> We look forward to seeing you on ${dayjs(selectedEvent)?.format('D')} ${Month(selectedEvent, language)}.</p></div>`} width = { isMobile ? "100%" : 450}/>
        </motion.div>
      ) :
      <>  
      <Box sx        = {{ width: isMobile ? "auto" : 450, position: "relative", pt: 5, pb: 4, px: 3, lineHeight: 1.3, }} >
      <Box sx        = {{ lineHeight: 1.5, }} >
      <Box className = "h3" sx = {{mb:2}}>
            {/* {language === "da" ? "Bestil fremvisning" : "Book viewing"} */}
            { buttonsLabel?.filter( btn => btn.UILabelProperty === 'OpenHouseBtnLabel')[0]?.Label }
            </Box>
          <Box  sx        = {{ mb: 2 }}>
          <span className = "paragraph1-regular">
             { buttonsLabel?.filter( btn => btn.UILabelProperty === 'OpenHouseHeading1')[0]?.Label }
            </span>
          </Box>
        </Box>
        
        <Grid sx = {{ display: "flex", flexDirection: "column", gap: "8px", mb: 2 }} item md = {12} xs = {10}>
        <Box  sx = {{ display: "flex", flexDirection: "row", gap: "8px" }}>
                    <Box>
                      <Icon isFaIcon="true" size="18" icon = "event-label" sx = {{ width: "18px", height: "18px" }} />
                    </Box>
                    <Box sx        = {{ display: "flex", flexDirection: "column", gap: "4px" }}>
                    <p   className = "h4">{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'Event')[0]?.Label }</p>
                    <p   className = "paragraph1-light">{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'OpenHouse')[0]?.Label } - {sEveData?.[0]?.Title}</p>
                    </Box>
                  </Box>
                  <Box sx = {{ display: "flex", flexDirection: "row", gap: "8px" }}>
                    <Box>
                      <Icon isFaIcon="true"  size="18" icon = "event-calendar" sx = {{ width: "18px", height: "18px" }} />
                    </Box>
                    
                    <Box sx        = {{ display: "flex", flexDirection: "column", gap: "4px" }}>
                    <p   className = "h4">{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'DataAndTime')[0]?.Label }</p>
                    <p   className = "paragraph1-light">{moment(sEveData?.[0]?.FromDate)?.format('dddd Do MMMM YYYY')}<br/> {sEveData?.[0]?.FromTime} - {sEveData?.[0]?.ToTime} {sEveData?.[0]?.timeGap}</p>
                    </Box>
                  </Box>
                  <Box sx = {{ display: "flex", flexDirection: "row", gap: "8px" }}>
                    <Box>
                      <Icon isFaIcon="true"  size="18" icon = "event-pin" sx = {{ width: "18px", height: "18px" }} />
                    </Box>
                    <Box sx        = {{ display: "flex", flexDirection: "column", gap: "4px" }}>
                    <p   className = "h4">{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'PropertyAddress')[0]?.Label }</p>
                    
                    <div className = "paragraph2-light" style = {{ width: 'fit-content'}}>{ sEveData?.[0]?.Address }</div>
                    </Box>
                  </Box>
              </Grid>
        <form onSubmit = {handleSubmit(onSubmit)} style = {{ background: '#ffffffe6', borderRadius: '16px', padding: '16px', marginTop: '24px' }} >
        <Grid item xs  = {12} sx                        = {{ pt: "0 !important" }}>
                  <FormControl
                      sx = {{ mb: 3 }}
                      fullWidth
                      variant = 'filled'
                      error   = {errors.firstname ? true : false}
                    >
                      <CustomLabel shrink className = "h5">
                        { buttonsLabel?.filter( btn => btn.UILabelProperty === 'ChooseOpenHouse')[0]?.Label }&nbsp;<span>*</span>
                      </CustomLabel>
                      <Box           sx   = {{ mt: 1 }}>
                      <EventCalendar unit = {unit} selectedEvent = {selectedEvent} setSelectedEvent = {setSelectedEvent} eventData = {eDates} />
                      </Box>
                  </FormControl>
                </Grid>
            <Grid
              container
              columnSpacing = {3}
              rowSpacing    = {grid ? 2 : 1}
              sx            = {{ mb: 3 }}
            >
              <Grid item xs = {12}>
              <Grid sx      = {{ gap: "16px" }}>
                <FormControl
                  sx = {{ mb: 2, gap: '8px' }}
                  fullWidth
                  variant = 'filled'
                >
                  <CustomLabel shrink  className = "h5">
                    {buttonsLabel?.filter( btn => btn.UILabelProperty === 'FullName')[0]?.Label || 'Fuldt navn'}&nbsp;<span>*</span>
                  </CustomLabel>
                <TextField
                    name="firstname"
                    label={buttonsLabel?.filter(btn => btn.UILabelProperty === 'FirstMiddleName')[0]?.Label || 'Fornavn og mellemnavn'}
                    placeholder="Fornavn"
                    required
                    control={control}
                    errors={errors}
                  />
                </FormControl>
                <FormControl sx = {{ mb: 3 }} fullWidth variant = 'filled'>
                 <TextField
                    name="lastname"
                    label={buttonsLabel?.filter(btn => btn.UILabelProperty === 'FormularEfternavn')[0]?.Label || 'Efternavn'}
                    placeholder="Efternavn"
                    required
                    control={control}
                    errors={errors}
                  />
                </FormControl>
              </Grid>
              </Grid>
              <Grid item xs = {12} sx = {{ pt: "0 !important" }}>
              <Grid sx      = {{ pt: "0 !important" }}>
                <FormControl
                  sx = {{ mb: '24px', gap: '8px' }}
                  fullWidth
                  variant = 'filled'
                >
                  <CustomLabel shrink  className = "h5">
                  {buttonsLabel?.filter( btn => btn.UILabelProperty === 'PrivateEmail')[0]?.Label || "Privat email"}&nbsp;<span>*</span>
                  </CustomLabel>
                  <EmailField
                      name="email"
                      label={buttonsLabel?.filter(btn => btn.UILabelProperty === 'FormularEmail')[0]?.Label || 'Email'}
                      placeholder="Email"
                      required
                      control={control}
                      errors={errors}
                    />
                </FormControl>
              </Grid>
              </Grid>
              <Grid item xs = {12} sx = {{ pt: "0 !important" }}>
              <Grid sx      = {{ gap: "16px" }}>
                <FormControl
                  sx = {{ mb: 3, gap: '8px' }}
                  fullWidth
                  variant = 'filled'
                >
                  <CustomLabel shrink  className = "h5">
                  {buttonsLabel?.filter( btn => btn.UILabelProperty === 'PhoneNumber')[0]?.Label || "Telefon nr."}&nbsp;<span>*</span>
                  </CustomLabel>
                  <PhoneNumberDropdown error = {errors.country_id || errors.phone ? true : false} helperText = {buttonsLabel?.filter( btn => btn.UILabelProperty === 'dropdownErrorWarn')[0]?.Label || "Indtast venligst et gyldigt telefonnummer"} options = {testLeadData?.D?.countries} control = {control} getPhoneId = {'country_id'} getPhoneNumber = {'phone'} placeholder = { buttonsLabel?.filter( btn => btn.UILabelProperty === 'Country')[0]?.Label || 'Land' } description = {buttonsLabel?.filter( btn => btn.UILabelProperty === 'CountryCodeDropdownDescription')[0]?.Label || "Søg landekode"} />
                </FormControl>
              </Grid>
              </Grid>
                  <Grid item xs = {12} sx = {{ pt: "0 !important" }}>
                   <Grid sx      = {{ gap: "16px" }}>
                      <FormControl
                        sx = {{ gap: '8px' }}
                        fullWidth
                        variant = 'filled'
                      >
                        <CustomLabel shrink  className = "h5">
                        {buttonsLabel?.filter( btn => btn.UILabelProperty === 'Dob')[0]?.Label }&nbsp;<span>*</span>
                        </CustomLabel>
                          <SelectDate style = {{ mb: 3, gap: '8px' }} setValue = {setValue} getValues = {getValues} watch = {watch} control = {control} dateOfBirth = {'dateOfBirth'} />
                      </FormControl>
                   </Grid>
                  </Grid>
                  {/* <Grid        item xs           = {12} sx                   = {{ pt: "0 !important" }}>
                  <FormControl fullWidth sx                = {{ gap: '0px' }}  variant = 'filled'>
                  <CustomLabel shrink  className = "h5">{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'FormularKommentar')[0]?.Label }</CustomLabel>
                    <CustomInput
                      multiline
                      placeholder={ buttonsLabel?.filter( btn => btn.UILabelProperty === 'commentPlaceholder')[0]?.Label }
                      rows = {4}
                      {...register('kommentar')}
                    />
                  </FormControl>
              </Grid> */}
            </Grid>
        
            <Box         sx        = {{ mb: 3, display: "flex", flexDirection: "column", gap: "8px" }}>
            <CustomLabel className = "h5">
                { buttonsLabel?.filter( btn => btn.UILabelProperty === 'FormularBetingelser')[0]?.Label }&nbsp;<span>*</span>
              </CustomLabel>
              <Box sx = {{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <FormControlLabel
                sx={{
                  mr        : 0,
                  ml        : 0,
                  gap       : '8px',
                  alignItems: 'flex-start',
                  "span"    : {    color: '#000' },
                  "a"       : {color: `${'#000'} !important` },
                }}
                control={
                  <CheckBox
                    name     = '_value'
                    checked  = {checked}
                    onChange = {handleCheckbox}
                    sx       = {{ p: 0 }}
                  />
                }
                label={
                      <Box >
                        <div>
                          <span className = "paragraph2-light">{ language == "da" ? "Accepter vores vilkår og betingelser." : "Accept our terms and conditions."}
                          <a    className = "h5" style = {{ textDecoration: 'none' }} href = {'https://estatetool.dk/'} target = "_blank"> { language == "da" ? "Læs mere her" : "Read more here" }</a>.</span>
                        </div>
                      </Box>
                }
              />
              </Box>
              <Box sx = {{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <FormControlLabel
                sx={{
                  mr        : 0,
                  ml        : 0,
                  gap       : '8px',
                  alignItems: 'flex-start',
                  "span"    : {    color: '#000' },
                  "a"       : {color: `${'#000'} !important` },
                }}
                control={
                  <CheckBox
                    name     = '_value'
                    checked  = {checked2}
                    onChange = {handleCheckbox2}
                    sx       = {{ p: 0 }}
                  />
                }
                label={
                      <Box >
                        <div>
                          <span className = "paragraph2-light">{ language == "da" ? "Accepter tilladelse til at modtage relevant markedsføringsmateriale." : "Accept permission to receive relevant marketing material."}
                          <a    className = "h5" style = {{ textDecoration: 'none' }} href = {'https://estatetool.dk/'} target = "_blank"> { language == "da" ? "Læs mere her" : "Read more here" }</a>.</span>
                        </div>
                      </Box>
                }
              />
              </Box>
            </Box>
            <Box
              sx={{
                position: { xs: isMobile ? "fixed" : "unset" },
                bottom  : 0,
                left    : 0,
                width   : "100%",
                zIndex  : '5',
                "button": {
                  width  : { xs: "100%", sm: "fit-content" },
                  height : { xs: "60px" , sm: "44px"},
                  padding: { xs: "12px 40px 30px 40px"}
                }
              }}
            >
              {
              isMobile 
                ?
                <EusButton
                    // {...props}
                clr             = {f_clr}
                type            = 'submit'
                onClick         = {()=> {}}
                borderRadius    = {"6px 6px 0px 0px;"}
                variant         = {"primary"}
                iconName        = {"next-arrow"}
                backgroundColor = {f_clr.ctaPrimary}
                disabled        = {!(checked && checked2) || !isValid }
                icon            = {true}
                size            = {12}
                iconAlign       = {"right"}
                buttonlabel     = {false}
                otherText       = { buttonsLabel?.filter( btn => btn.UILabelProperty === 'signUp')[0]?.Label || 'Tilmeld' }
                iconSize        = {"xl"}
                isFaIcon        = {false}
              />
                : 
                <CustomButton
                type      = 'submit'
                className = "eus-button-2"
                clr       = {f_clr}
                disabled  = {!(checked && checked2) || !isValid}
                variant   = "primary"
                padding   = {"12px 24px"}
              >
                  { buttonsLabel?.filter( btn => btn.UILabelProperty === 'signUp')[0]?.Label || 'Tilmeld' }
              </CustomButton>
              }
            </Box>
        </form>
      </Box>
      </>
    }
      </>
    <PoweredBy padding = { sm ? "0 0 66px 0" : atUnit || atFrontpage || atPropertyPage ? '16px 0 16px 0px' : "16px 0 16px 0px"} clr = "#FFF"/>
    </Drawer>
  );
};

export default OpenHouseDrawer;


{/* <SuccessMessage label={false} msg={language === "da" ? <p>Vi har registreret dit ønske om at bestille en fremvisning.<br/> Du vil blive kontaktet af vores mægler for at aftale nærmere.</p> : <p>We have registered your wish to order a screening. <br />You will be contacted by our broker to make further arrangements</p>} width={422}/> */}